import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleDown} from "@fortawesome/free-solid-svg-icons/faCircleDown";
import FilterDropdown from "../FilterDropdown.jsx";
import Badge from "../Badge.jsx";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

function SourceFilter() {
    let {context} = useContext(GlobalContext);
    let {sourcesPossible, sourcesRemoved, setSourcesRemoved} = useContext(FilterContext);

    let {t} = useTranslation();

    let project = useMemo(
        () => {
            for (let p of context.currentUserProjects) {
                if (p.id === context.currentProjectId) {
                    return p;
                }
            }

            return null;
        },
        [sourcesPossible, sourcesRemoved, context.currentProjectId]
    );

    let toggle = (source) => {
        sourcesRemoved = [...sourcesRemoved];

        if (sourcesRemoved.includes(source)) {
            sourcesRemoved = sourcesRemoved.filter((s) => s !== source);
        } else {
            sourcesRemoved.push(source);
        }

        setSourcesRemoved(sourcesRemoved);
    };

    let enabledAccounts = useMemo(
        () => {
            let enabledAccounts = sourcesPossible.length;

            for (let possibleValue of sourcesPossible) {
                if (sourcesRemoved.includes(possibleValue)) {
                    enabledAccounts--;
                }
            }

            return enabledAccounts;
        },
        [sourcesRemoved, sourcesPossible]
    );

    let [selectAllChecked, setSelectAllChecked] = useState(false);

    useEffect(() => {
        setSelectAllChecked(sourcesRemoved.length === 0);
    }, [sourcesPossible, sourcesRemoved, project?.id]);

    let resolveSelectAll = () => {

        if(sourcesPossible === 0) {
            setSelectAllChecked(!selectAllChecked);
        }

        if (sourcesRemoved.length === 0) {
            setSourcesRemoved(sourcesPossible);
            setSelectAllChecked(false);
        } else {
            setSourcesRemoved([]);
            setSelectAllChecked(true);
        }
    };

    return (<FilterDropdown
        title={t('filter.sources')}
        align={'right'}
        button={<div className={'flex justify-center items-center text-nowrap gap-1'}>
            <FontAwesomeIcon icon={faCircleDown}/>
            {t('filter.sources')}
            {enabledAccounts < sourcesPossible.length && <Badge>{enabledAccounts}/{sourcesPossible.length}</Badge>}
        </div>}
    >
        <ul>
            <li className="py-1 px-3 border-b-1">
                <label className="flex items-center select-none">
                    <input
                        type="checkbox" className="form-checkbox"
                        onChange={resolveSelectAll}
                        checked={selectAllChecked}
                    />
                    <span className="text-sm font-medium ml-2">{t('filter.select-all')}</span>
                </label>
            </li>
            {sourcesPossible && sourcesPossible.map(source => {
                if (project?.forbiddenChannels.includes(source) === true) {
                    return null;
                }

                return <li className="py-1 px-3" key={source}>
                    <label className="flex items-center select-none">
                        <input type="checkbox" className="form-checkbox" onChange={() => toggle(source)}
                               checked={!sourcesRemoved.includes(source)}/>
                        <span className="text-sm font-medium ml-2">{source}</span>
                    </label>
                </li>;
            })}
        </ul>
    </FilterDropdown>);
}

export default SourceFilter;
